export interface GlossaryEntry {
  id: string;
  term: string;
  definition: string;
  category?: string;
}

export interface ReferenceData {
  sets: string[];
  factions: string[];
  championTypes: string[];
  rarities: string[];
  keywords: string[];
  mechanics: string[];
  utilityTypes: string[];
  equipmentSubtypes: string[];
  secondarySubtypes: string[];
  glossary: GlossaryEntry[];
  weaponTypes: string[];
}

export const DEFAULT_REFERENCE_DATA: ReferenceData = {
  sets: ["Ashes of The Arena"],
  factions: ["Gladiator", "Imperial"],
  championTypes: ["Speed", "Strength", "Will", "Tactics"],
  rarities: ["Common", "Uncommon", "Rare", "Ultra Rare", "Legendary"],
  keywords: ["Stun", "Reflect", "Displace", "Disarm", "Piercing", "Crush", "Quick", "Perry", "Serrated"],
  mechanics: [
    "Focus", "Edge", "Fortify", "Sacrifice", "Expend", "+X Block", "+X Power",
    "Bounty Marker", "Condemn", "Discard", "Reveal", "Gain X Stamina", "Negate",
    "Reduce Next Action's Stamina Cost", "Draw cards", "full block", "deal damage",
    "take damage", "copy", "reduce stamina cost", "gain life", "block reduction",
    "anti-draw", "stamina recover", "exhaust weapon", "add wear counter", "counter",
    "ready weapon", "search", "reveal", "ready",
  ],
  utilityTypes: ["Maneuver", "Reaction", "Item"],
  equipmentSubtypes: ["Weapon", "Shield", "Quiver"],
  secondarySubtypes: ["Sword", "Axe", "Mace", "Spear", "Bow", "Dagger", "Staff", "Crossbow"],
  glossary: [],
  weaponTypes: ["Sword", "Axe", "Mace", "Spear", "Bow", "Shield", "Quiver"],
};
